import { createFileRoute, Outlet } from "@tanstack/react-router";
import { bookingDetailSearchSchema } from "@/features/bookings/bookings-search";
import { requireAuth } from "@/lib/auth-guard";

export const Route = createFileRoute("/bookings/$id")({
  beforeLoad: requireAuth,
  validateSearch: bookingDetailSearchSchema,
  component: BookingIdLayout,
});

function BookingIdLayout() {
  return <Outlet />;
}
